import React from 'react';
import { Bell, Clock, AlertTriangle, TrendingUp, Target, MessageSquare, Calendar } from 'lucide-react';

const IconSelector = ({ type, size = 16 }) => {
  switch (type) {
    case 'Wealth Event':
      return <TrendingUp size={size} className="text-green-600" />;
    case 'Market Event':
      return <Target size={size} className="text-primaryDark" />;
    case 'Life Event':
      return <Clock size={size} className="text-purple-600" />;
    case 'Portfolio Alert':
      return <AlertTriangle size={size} className="text-orange-600" />;
    case 'Conversation':
      return <MessageSquare size={size} className="text-green-600" />;
    case 'Meeting':
      return <Calendar size={size} className="text-purple-600" />;
    default:
      return <Bell size={size} className="text-gray-600" />;
  }
};

export default IconSelector;